import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface PersistViewSettingsDialogProps {
  /** Whether the prompt is showing. */
  open: boolean;
  /** One line per changed setting, from {@link describeChangedViewSettings}. */
  changeLines: string[];
  /** AlertDialog open/close handler (Escape dismisses without choosing). */
  onOpenChange: (open: boolean) => void;
  /** "Keep for next images" — persist the current settings for the session. */
  onKeep: () => void;
  /** "Reset each time" — drop settings on every navigation for the session. */
  onReset: () => void;
}

/**
 * Asked once per session the first time a reviewer navigates after changing a
 * tracked view setting. Lists what changed and lets them keep those settings for
 * the rest of the images or reset back to defaults on each one.
 */
export function PersistViewSettingsDialog({
  open,
  changeLines,
  onOpenChange,
  onKeep,
  onReset,
}: PersistViewSettingsDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Keep these view settings for the next images?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>
              <ul className="mb-3 list-disc space-y-1 pl-5">
                {changeLines.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
              <p>These settings stay applied as you review and navigate between images.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onReset}>Reset each time</AlertDialogCancel>
          <AlertDialogAction onClick={onKeep}>Keep for next images</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
